import React from 'react';
import {PanelWrapper, PanelBody, PanelHeader, PanelFooter, Divider} from './style';

export const Panel = (props) => (
	<PanelWrapper show={props.show}>
		<PanelBody {...props}>
			{props.children}
		</PanelBody>
	</PanelWrapper>
) 

export {
	PanelHeader,
	PanelFooter,
	Divider
};